module.exports = "/assets/logo_sg_lightroom_1_1_classic-24c1e8a30bc6ebad6ca50e3c34f1735b.png";